<template>
  <div class="succeed">
    <div class="succeed-box">
      <div class="succeed-icon">
        <img src="@assets/img/succeed.png" />
      </div>
      <p>Login was successful！</p>
      <div class="succeed-count">
        <span>{{time}}</span>s后返回
      </div>
      <Button type="primary" @click="goTo" size="large" style="width: 300px;">Back</Button>
    </div>
  </div>
</template>

<script>
export default {
  name: "succeed",
  data() {
    return {
      time: 3,
      timer: null,
      hasHistory: true
    };
  },
  created() {
    this.reduceNum();
  },
  methods: {
    reduceNum() {
      this.timer = setInterval(() => {
        --this.time;
        if (this.time === 0) {
          window.clearInterval(this.timer);
          this.goTo();
        }
      }, 1000);
    },
    goTo() {
      this.$router.push({ path: "/homeEn" });
    }
  },
  destroyed() {
    this.timer = null;
  }
};
</script>

<style scoped lang="scss">
.succeed {
  width: 1200px;
  margin: 20px auto;
  &-box {
    width: 320px;
    margin: 60px auto 0;
    text-align: center;
  }
  p {
    margin-bottom: 40px;
    font-size: 18px;
    color: #333;
  }
  &-icon {
    margin-bottom: 18px;
  }
  &-count {
    font-size: 14px;
    margin-bottom: 48px;
    color: #333;
    span {
      color: #015293;
    }
  }
}
</style>
